import { useTranslate } from "ui/locale";
import { UseFormatRelativeTimeOptions, UseFormatRelativeTimeResult } from "./useFormatRelativeTime.types";

/**
 * Hook to format a date using Intl.RelativeTimeFormat
 * @see https://developer.mozilla.org/es/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat
 */
export default function (): UseFormatRelativeTimeResult {
    const translate = useTranslate();
    return (value: number, options: UseFormatRelativeTimeOptions = {}) => {
        return translate("formatRelativeDate", { val: value, ...options }).capitalize();
    };
}
